'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Spinner = require('./Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComponentSpinner = function ComponentSpinner(props) {
    return _react2.default.createElement(_Spinner2.default, _extends({}, props, {
        ariaLive: 'polite',
        size: '3x',
        role: undefined
    }));
};

ComponentSpinner.propTypes = _Spinner.spinnerProps;

exports.default = ComponentSpinner;